
<template>
    <div class="app-nav-wrap">

        <el-menu :default-active="this.$route.path" :router="true" :collapse="isCollapse" :class="[isCollapse?'menu_hidden':'menu_open']"
                 background-color="#10214c" text-color="#8bcfff" active-text-color="#fff" unique-opened>


            <template v-for="item in listMenuLeft">


                <!-- 111111-->
                <el-menu-item v-if="!item.listMenuDTO || item.listMenuDTO.length==0" :key="item.url" :index="item.url">
                    <i :class="item.icon"></i>
                    <span slot="title">{{item.name}}</span>
                </el-menu-item>


                <el-submenu v-else-if="item.listMenuDTO || item.listMenuDTO.length>0" :index="item.url" :key="item.url">
                    <template slot="title">
                        <i :class="item.icon"></i>
                        <span slot="title">{{item.name}}</span>
                    </template>



                    <!-- just for 2 level-->
                    <template v-for="sub2 in item.listMenuDTO">
                        <!-- 222222-->
                        <el-menu-item v-if="!sub2.listMenuDTO || sub2.listMenuDTO.length==0" :index="sub2.url" :key="sub2.url" class="subs">
                            <i class="el-icon-caret-right"></i>
                            <span slot="title">{{sub2.name}}</span>
                        </el-menu-item>
                    </template>




                    <!-- just for 3 level-->
<!--                    <el-menu-item-group>-->
<!--                        <template v-for="sub2 in item.children">-->

<!--                            &lt;!&ndash; 222222&ndash;&gt;-->
<!--                            <el-menu-item v-if="!sub2.children || sub2.children.length==0" :index="sub2.route" :key="sub2.route">-->
<!--                                <i class="el-icon-menu"></i>-->
<!--                                <span slot="title">{{sub2.name}}</span>-->
<!--                            </el-menu-item>-->

<!--                            <el-submenu v-else-if="sub2.children || sub2.children.length>0" :key="sub2.route" :index="sub2.route">-->
<!--                                <template slot="title">-->
<!--                                    <i class="el-icon-menu"></i>-->
<!--                                    <span slot="title">{{sub2.name}}</span>-->
<!--                                </template>-->

<!--                                <el-menu-item-group>-->
<!--                                    <template v-for="sub3 in sub2.children">-->
<!--                                        &lt;!&ndash; 333333&ndash;&gt;-->
<!--                                        <el-menu-item :index="sub3.route" :key="sub3.route">-->
<!--                                            <i class="el-icon-menu"></i>-->
<!--                                            <span slot="title">{{sub3.name}}</span>-->
<!--                                        </el-menu-item>-->
<!--                                    </template>-->
<!--                                </el-menu-item-group>-->
<!--                            </el-submenu>-->

<!--                        </template>-->
<!--                    </el-menu-item-group>-->



                </el-submenu>


            </template>


        </el-menu>


    </div>
</template>

<script>
    export default {
        props: ["isCollapse"],
        data () {
            return{
                listMenuLeft:this.$store.state.listMenuLeft,
            }
        },
        watch: {

            //监听局部变量
            listMenuLeft(newValue, oldValue) {
                console.log(newValue+"--"+oldValue)
            },

            //监听全局变量
            '$store.state.listMenuLeft' : function(val){
                console.log(val);
                this.listMenuLeft = val;
            },
        },
        methods:{

        }

    }
</script>


<style>


    .el-menu{
        border-right-width: 0px;
    }

    div.el-menu-item-group__title{
        padding: 0px;
    }
    .is-opened  .el-submenu__title i {
        color: #fff;
    }
    .is-opened .el-submenu__title{
        color: #fff !important;
        background-color: #1775ea !important;
    }
    .el-menu-item i{
        color: #8bcfff;
    }
    /* .el-submenu.is-active .el-submenu__title {
        color: #fff !important;
        background-color: #1775ea !important;
    } */
    .el-submenu__title{
        color: #b8c7ce !important;
    }
    .el-submenu__title i{
        color: #b8c7ce ;
    }
    li.subs{
        background-color: #173681 !important;
        padding-left: 23px !important;
    }
    i.el-icon-caret-right{
        width: 20px !important;
        font-size: 10px !important;
    }

    li.el-menu-item.subs{
        min-width: auto;
    }





</style>

<style lang="scss" scoped>

    .app-nav-wrap{
        height: 100%;
        
        
        .menu_hidden{
            span {
                font-size: 0px;
            }
        }

    }

    .el-menu{
        height: 100%;
    }


</style>
